import type { ReactNode } from 'react';
import type React from 'react';
import { userItemsTitleBar } from './userItemsTitleBar.styles';

type UserItemsTitleBarProps = {
  children: ReactNode;
};

const UserItemsTitleBar: React.FC<UserItemsTitleBarProps> = ({ children }) => {
  return <h1 className={userItemsTitleBar}>{children}</h1>;
};

export default UserItemsTitleBar;
